/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction } from 'state/ui/actions';

const openModal = createOpenModalAction('RenameReportPopover');

export default (reportId) => (dispatch) => {
	dispatch({ type: actions.REPORT_RENAME_FORM_START, payload: { reportId } });
	dispatch(openModal());
};
